export interface CirclePacking {
  id: string;
  label: string;
  parent?: string;
  children?: Array<this>;
  ancestors?: Array<this>;
  doc_count?: number; // TODO: change this for value
  childrenOnlyCount?: number; // TODO use instead childrenValue
  depth?: number;
  x?: number;
  y?: number;
  r?: number;
  color?: string;
  wrappedText?: {
    lines: Array<string>;
    fontSize: number;
  };
}

export interface CirclePackingForce {
  x: number;
  y: number;
}

export interface CirclePackingWrappedText {
  fontSize: number;
  totalLines: number;
}

export enum ClusterType {
  TEXT = 'text',
  CIRCLES = 'circles'
}

export interface CirclePackingZoomBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

export enum CanvasCursor {
  GRABBING = 'grabbing',
  GRAB = 'grab'
}
